export enum AlisProductName {
  ALI_LOAN_INSURANCE = 'Låneforsikring',
  ALI_CANCER_INSURANCE = 'Kreftforsikring',
  ALI_PENSION_INSURANCE = 'Pensjonsforsikring',
  ALI_CAPITAL_INSURANCE = 'Kapitalforsikring',
  ALI_ANNUITY_WITH_SECURITY_INSURANCE = 'Livrente med sikring av s',
  CHILD_STANDARD = 'Standard Barneforsikring',
  CHILD_EXTENDED = 'Utvidet Barneforsikring',
  CHILD_CONTINUED = 'Barneforsikring Viderefør',
  CHILD_SUPER = 'Super Barneforsikring',
}

export const AlisInsurances = [
  AlisProductName.ALI_LOAN_INSURANCE,
  AlisProductName.ALI_CANCER_INSURANCE,
  AlisProductName.ALI_PENSION_INSURANCE,
  AlisProductName.ALI_CAPITAL_INSURANCE,
  AlisProductName.ALI_ANNUITY_WITH_SECURITY_INSURANCE,
];

export const AlisChildInsurances = [
  AlisProductName.CHILD_STANDARD,
  AlisProductName.CHILD_EXTENDED,
  AlisProductName.CHILD_CONTINUED,
  AlisProductName.CHILD_SUPER,
];

export const OVERVIEW_LINK_DETAILS = 'overview.link.details';
